import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/IToolsRepository').IToolsRepository} */
export class ToolsRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getTools(options = {}) {
    return this.client.get(ENDPOINTS.TOOLS.BASE, {
      params: options,
    });
  }

  async createTool(toolData) {
    return this.client.post(ENDPOINTS.TOOLS.BASE, toolData);
  }

  async getToolById(toolId) {
    return this.client.get(ENDPOINTS.TOOLS.BY_ID(toolId));
  }

  async updateTool(toolId, updateData) {
    return this.client.patch(ENDPOINTS.TOOLS.BY_ID(toolId), updateData);
  }

  async deleteTool(toolId) {
    return this.client.delete(ENDPOINTS.TOOLS.BY_ID(toolId));
  }

  async getDependentAgents(toolId) {
    return this.client.get(ENDPOINTS.TOOLS.DEPENDENT_AGENTS(toolId));
  }
}
